/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './index.module.css';

export default function ClickableDiv({
  onClick,
  keyCodes,
  className,
  children,
  ...props
}) {
  const handleClick = (action) => {
    onClick(action);
  };
  const handleKeyPress = (e) => {
    if (keyCodes.includes(e.code)) {
      handleClick();
    }
  };
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyPress}
      className={classNames(Styles.mainContainer, className)}
      {...props}
    >
      {children}
    </div>
  );
}

ClickableDiv.propTypes = {
  onClick: PropTypes.func,
  keyCodes: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  children: PropTypes.node,
};

ClickableDiv.defaultProps = {
  onClick: () => {},
  keyCodes: ['Space', 'Enter'],
  className: '',
  children: null,
};
